import { Directive, ElementRef, Renderer2 } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { getUser } from "@edp-store/selectors/user.selectors";

@Directive({
  selector: "[impersonateDisable]"
})
export class ImpersonateDisableDirective {

  private claims: any;

  constructor(
    private store: Store<IAppState>, el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.store.select(getUser).subscribe(user => {

      this.claims = user.claims && JSON.parse(user.claims);

      if (this.claims && this.claims.AccessLevel !== "SUPERUSER") {
        this.renderer.setAttribute(el.nativeElement, "disabled", "true");
        this.renderer.setAttribute(el.nativeElement, "style", "pointer-events: none; opacity: 0.5;");
      }
    });
  }

}
